<div class="loan-option-panel">
    <slot/>
</div>


<style lang="less">
    .loan-option-panel{
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 16px
    }
</style>